<template>
    <tr @click="$emit('click')">
        <template v-for="column in filteredColumns">
            <component
                :is="is"
                v-if="column.display != null ? column.display : true"
                :key="column.name"
                :colspan="column.colspan || 1"
                :class="[column.class, `col-costs-${column.name}`]"
                :style="[column.style]"
            >
                <slot :name="column.name" />
            </component>
        </template>

    </tr>
</template>

<script>
export default {
    props: {
        headings: {
            type: Boolean,
            default: false,
        },
        isHeadingRow: {
            type: Boolean,
            default: false,
        },
        headingClass: {
            type: String,
            default: '',
        },
    },
    computed: {
        is() {
            return this.headings ? 'th' : 'td';
        },
        columns() {
            return [
                ...this.$store.getters['costable/leftColumns'],
                ...this.middleColumns,
                ...this.$store.getters['costable/rightColumns'],
            ];
        },
        filteredColumns() {
            return this.columns
                .filter(column => (column.display != null ? column.display : true))
                .filter(column => (!this.$store.getters['costable/hiddenColumns'].includes(column.name)));
        },
        middleColumns() {
            const middleColumns = this.$store.getters['costable/middleColumns'];

            if (this.isHeadingRow) {
                const middleColumnsLength = middleColumns
                    .filter(column => (column.display != null ? column.display : true))
                    .filter(column => (!this.$store.getters['costable/hiddenColumns'].includes(column.name)))
                    .length;

                return [
                    {
                        name: 'heading',
                        colspan: middleColumnsLength,
                        class: this.headingClass,
                    },
                ];
            }

            return middleColumns;
        },
    },
};
</script>

<style lang="scss" scoped>
.larger-font {
    font-size: 14px;
}
.bolder-font {
    font-weight: 600;
}
.resources-cube-icon {
    display: none;
    cursor: pointer;
}
.CostableTableCost:hover {
    .resources-cube-icon {
        display: inline-block;
    }
}
</style>
